import styled from "styled-components";

import { colors } from "../../consts";
import { Paragraph2 } from "../Text/Paragraphs";

export const AccordionMainOption = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding: 12px 16px;

  border: 1px solid ${colors.RAISIN_20};
  border-radius: 16px;
  cursor: pointer;

  ${(props) =>
    props?.isOpen &&
    `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  `};

  & ${Paragraph2} {
    font-weight: 600;
    color: ${colors.RAISIN_80};
  }

  * {
    transition: all 0.2s ease-in;
  }
`;

export const AccordionSubOptions = styled.div`
  margin-top: -16px;
  padding: ${(props) => (props?.isOpen ? "12px 16px 0" : "0")};

  height: ${(props) => (props?.isOpen ? "min-content" : 0)};
  width: 100%;

  border: 1px solid ${colors.RAISIN_20};
  border-radius: 0 0 16px 16px;
  border-top: none;

  ${(props) =>
    props?.isOpen ? "animation: growDown 300ms ease-in-out forwards" : "transform: scaleY(0)"};

  transition: height 0.2s ease-in;
  transform-origin: top center;
`;

export const OptionsWrapper = styled.div`
  width: 100%;
  height: 100%;

  overflow: scroll;
`;
